import { ResponseError, mapResponseErrors } from '../errors';
export function assertCallbackResponseError(result, domain) {
  if (result.date) {
    return;
  }

  var _ref = result,
      errors = _ref.errors;
  var details = mapResponseErrors(errors || []);
  throw new ResponseError({
    domain: domain,
    message: 'Request callback response error',
    details: details
  });
}